import { DropdownSingleSelect } from "components/DropdownSingleSelect";
import { useTranslation } from "react-i18next";

import type { CrremDisplayMetric, CrremSettings, EnergyAnalysisSettingsChange } from "../model/types";

import { CRREM_DISPLAY_METRIC, isCrremDisplayMetric } from "../model/constants";
import { EnergyAnalysisSettingsGroup } from "./EnergyAnalysisSettingsGroup";

const DISPLAY_METRICS: CrremDisplayMetric[] = [CRREM_DISPLAY_METRIC.kwh, CRREM_DISPLAY_METRIC.co2];

type EnergyAnalysisMetricSelectProps = {
  disabled?: boolean;
  onChange: EnergyAnalysisSettingsChange;
  settings: CrremSettings;
};

export const EnergyAnalysisMetricSelect = ({ disabled, onChange, settings }: EnergyAnalysisMetricSelectProps) => {
  const { t } = useTranslation();
  return (
    <EnergyAnalysisSettingsGroup iconName="Energy" label={t("BuildingProfile.energyAnalysis.settings.metric") as string}>
      <DropdownSingleSelect
        className="w-56"
        clearable={false}
        disabled={disabled}
        displayOptions={DISPLAY_METRICS.map((metric) => t(`BuildingProfile.energyAnalysis.settings.${metric}`))}
        height="3.2rem"
        hideLabel
        options={DISPLAY_METRICS}
        selectedValue={settings.displayMetric}
        setSelectedValue={(value) => {
          if (isCrremDisplayMetric(value)) onChange("displayMetric", value);
        }}
      />
    </EnergyAnalysisSettingsGroup>
  );
};
